import { render, staticRenderFns } from "./groupProvinces.vue?vue&type=template&id=67fcfe00&scoped=true"
import script from "./groupProvinces.vue?vue&type=script&lang=js"
export * from "./groupProvinces.vue?vue&type=script&lang=js"
import style0 from "./groupProvinces.vue?vue&type=style&index=0&id=67fcfe00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fcfe00",
  null
  
)

export default component.exports